import moment from 'moment';

import { getParentDomain } from 'components/utils/function';

/**
 * Check env lottery
 */
export const isLottery = window.appName === 'lottery';
export const isWallet = window.appName === 'wallet';
export const isTh88 = window.appName === 'thl';
export const isEngineTmgaming = window.engine === 'tmgaming';
export const isEngineN1tro = window.engine === 'n1tro';

/**
 * All environment
 */
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const API_URL = process.env.NODE_ENV === 'development' ? window.apiUrl : (window.apiUrl + getParentDomain());
export const SOCKET_API_URL = (process.env.NODE_ENV === 'development' ? window.socketUrl : (window.socketUrl + getParentDomain())) + '/ws';
export const checkIsAfterDate = (startDate, endDate) => {
    return moment(moment(startDate || new Date(), 'DD/MM/YYYY')).isAfter(moment(endDate || new Date(), 'DD/MM/YYYY'));
};

export const downloadFile = (url) => {
    if (!url) {
        return;
    }
    const link = document.createElement('a');
    const downloadFilename = url + '?';
    link.href = url;
    link.download = downloadFilename;
    document.body.appendChild(link);
    link.click();
    link.remove();
};
